const baseStyleOverlay = {
  bg: "blackAlpha.600",
  zIndex: 1400
};

const baseStyleDialogContainer = (props) => {
  const { isCentered, scrollBehavior } = props;
  return {
    display: "flex",
    zIndex: 1400,
    justifyContent: "center",
    alignItems: isCentered ? "center" : "flex-start",
    overflow: scrollBehavior === "inside" ? "hidden" : "auto"
  };
};

const baseStyleDialog = (props) => {
  const { scrollBehavior } = props;
  return {
    // my: "3.75rem",
    zIndex: 1400,
    maxH: scrollBehavior === "inside" ? "calc(100% - 7.5rem)" : undefined,
    width: "auto"
  };
};

const baseStyleBody = (props) => {
  const { scrollBehavior } = props;
  return {
    flex: 1,
    borderRadius: "12px",
    bg: "surfaceElevated1",
    boxShadow: "elevation2",
    overflow: scrollBehavior === "inside" ? "auto" : undefined
  };
};

const baseStyle = (props) => ({
  overlay: baseStyleOverlay,
  dialogContainer: baseStyleDialogContainer(props),
  dialog: baseStyleDialog(props),
  body: baseStyleBody(props)
});

export default {
  baseStyle
};
